module.exports = "#version 300 es\nprecision highp float;\n\nuniform mat4 u_Model;\nuniform mat4 u_ModelInvTr;  \n\nuniform mat4 u_View;   \nuniform mat4 u_Proj; \nuniform mat4 u_ViewProj;\n\nin vec4 vs_Pos;\nin vec4 vs_Nor;\nin vec4 vs_Col;\nin vec2 vs_UV;\n\nout vec4 fs_Pos;\nout vec4 fs_Nor;            \nout vec4 fs_Col;           \nout vec2 fs_UV;\n\nvoid main()\n{\n    fs_Col = vs_Col;\n    fs_UV = vs_UV;\n    fs_UV.y = fs_UV.y;\n  \n    fs_Nor = vs_Nor;\n    fs_Pos = vs_Pos;    \n    gl_Position = u_ViewProj * u_Model * vs_Pos;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/standard-vert.glsl
// module id = 6
// module chunks = 0